var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "2700",
                  reset: true,
                  "custom-search-items": _vm.customSearchItems,
                  "is-append-query": true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "CargoMsg.Cargo_QueryTip"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex" },
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 5px 0 15px" },
                        attrs: { no: "12" },
                        on: { change: _vm.resetTimer },
                        model: {
                          value: _vm.autoRefreshCabinList,
                          callback: function($$v) {
                            _vm.autoRefreshCabinList = $$v
                          },
                          expression: "autoRefreshCabinList"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AutomaticallyRefresh")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "27000522",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c(
                  "div",
                  {
                    class: "fixedBottom",
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      "flex-wrap": "wrap"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selectedRows.length > 0,
                            expression: "selectedRows.length > 0"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Clearing.Selected") +
                                _vm.selectedRows.length +
                                ":" +
                                _vm.selectRowDataLabel
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c("cargo-pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.appendQuery && _vm.filter.total > 0,
                      expression: "!appendQuery && filter.total>0"
                    }
                  ],
                  attrs: {
                    "config-module": "27000521",
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.appendQuery,
                        expression: "appendQuery"
                      }
                    ],
                    staticClass: "pagination-container"
                  },
                  [
                    _c("el-pagination", {
                      staticStyle: { "text-align": "left" },
                      attrs: { total: _vm.filter.total, layout: "total" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }